/* import __COLOCATED_TEMPLATE__ from './navbar-adapter.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import {
  isStandaloneRoute,
  expiredSubscriptionRoute,
} from 'embercom/helpers/standalone/standalone-routes';
import type RouterService from '@ember/routing/router-service';
import routeRegexes from 'embercom/lib/route-regexes';
import { tracked } from '@glimmer/tracking';
import type Session from 'embercom/services/session';

interface Args {}

export default class NavbarAdapter extends Component<Args> {
  @service declare appService: AppService;
  @service declare router: RouterService;
  @service declare session: Session;
  @tracked isLoadingApp = false;

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    this.ensureAppIsLoaded();
  }

  async ensureAppIsLoaded() {
    if (this.appService.app || !this.onInboxRoute) {
      return;
    }

    this.isLoadingApp = true;
    await this.appService.loadApp(this.session.workspace.id);
    this.isLoadingApp = false;
  }

  get onInboxRoute() {
    return (
      this.router.currentRouteName?.match(routeRegexes.inbox) ||
      this.router.currentRouteName?.match(routeRegexes.inbox2)
    );
  }

  get isBillingOrSettingsRoute() {
    let route = this.router.currentRouteName;
    return route.startsWith('apps.app.billing') || route.startsWith('apps.app.settings');
  }

  get isValidRoute() {
    return (
      (isStandaloneRoute(this.router.currentRouteName) ||
        this.router.currentRouteName === expiredSubscriptionRoute) &&
      this.router.currentRouteName !== 'apps.app.standalone-platform-switch'
    );
  }

  get isMainAppLoading() {
    return (
      this.router.currentRouteName === 'apps.app.loading' ||
      this.router.currentRouteName === 'inbox_loading'
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Adapters::NavbarAdapter': typeof NavbarAdapter;
  }
}
